import { defineComponent as _defineComponent } from 'vue'
import {onMounted, PropType, ref, unref} from "vue";
import {useI18n} from "@/composables/useI18n";
import {FileDownload} from "@/scripts/Common/FileDownload";
import {
  DownloadSepaDocument,
  fetchSepaDocuments,
  ResetSepaDocument,
  SepaExport,
  SepaQueryParams,
  TransactionTypeFilter
} from "@/components/bankTransfers/scripts";
import {Pagination} from "@/scripts/Common/paginationType";
import {BankTransferList, BankTransferSearchFilter} from "@/components/bankTransfers/children";
import {ErrorCodes, TransactionType} from "@/Enums";
import {ErrorDialog} from "@/components/dialogs";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerBankTransfers',
  props: {
  token: {
    required: true,
    type: String as PropType<string>,
  },
  hasEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  hasDownloadRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  }
},
  setup(__props) {

const props = __props;

const {
  t,
} = useI18n();

const transactionTypes = [
  {
    id: TransactionType.all,
    value: t('transaction_type_all'),
  },
  {
    id: TransactionType.terminal,
    value: t('transaction_type_terminal'),
  },
  {
    id: TransactionType.other,
    value: t('transaction_type_other'),
  },
] as TransactionTypeFilter[];



const sepaExports = ref<SepaExport[]>([]);

let queryParams = {
  sepaType: undefined,
  transactionType: transactionTypes.filter(type => type.id !== TransactionType.all).map(type => type.id),
  debitType: undefined,
  accountingStartDate: undefined,
  accountingEndDate: undefined,
  hasError: undefined,
} as SepaQueryParams;

const pagination = ref<Pagination>({
  pageCount: 0,
  page: 1,
  itemsPerPage: 8
});

const fetchError = ref<any>();

const hasNoEditRights = !props.hasEditRights;
const hasNoDownloadRights = !props.hasDownloadRights;

const onHandleFetchError = ({error}: { error: any }) => {
  fetchError.value = error;
};

const fetchSepas = async () => {
  sepaExports.value = [];

  const {error, response, paginationCount} = await fetchSepaDocuments(props.token, queryParams, unref(pagination));

  if (error || !response) {
    onHandleFetchError({error});
    return;
  }

  pagination.value.pageCount = paginationCount ?? 0;
  sepaExports.value = response;
};

const onHandleFilterUpdate = (filter: SepaQueryParams) => {
  queryParams = {...filter}
  fetchSepas();
}

const Download = async ({sepaDocumentId, filename}: { sepaDocumentId: number, filename: string }) => {
  const {error, response} = await DownloadSepaDocument(sepaDocumentId, props.token);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  FileDownload.Create(response, filename);

  fetchSepas();
}

const Reset = async (sepaDocumentId: number) => {
  const {error, response} = await ResetSepaDocument('sepaSaleReset', sepaDocumentId, props.token);

  if (error || !!(response as SepaExport).error) {
    const tmpError = { ErrorCode: ErrorCodes.err_reset_not_possible }
    onHandleFetchError({error: tmpError });
    return;
  }

  fetchSepas();
}

const onHandleErrorDialogCancelOrConfirm = () => {
  fetchError.value = undefined;
}

onMounted(() => {
  fetchSepas();
});

return { __sfc: true,t, transactionTypes, props, sepaExports, queryParams, pagination, fetchError, hasNoEditRights, hasNoDownloadRights, onHandleFetchError, fetchSepas, onHandleFilterUpdate, Download, Reset, onHandleErrorDialogCancelOrConfirm, BankTransferList, BankTransferSearchFilter, ErrorDialog }
}

})